"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Facebook;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import React from 'react';
// export default function Facebook(props) {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={100} height={100} {...props}>
//       <defs>
//         <style dangerouslySetInnerHTML={{__html: ".cls-1{fill:#010101;}" }} />
//       </defs>
//       <title>Facebook</title>
//       <g id="Social_media" data-name="Social media">
//         <path id="facebook" className="cls-1" d="M41.359,90V54.219H29.375V40H41.359V28.8c0-12.172,7.438-18.8,18.3-18.8a100.909,100.909,0,0,1,10.969.562V23.281H63.094c-5.907,0-7.047,2.813-7.047,6.922V40H69.375L67.547,54.219h-11.5V90" />
//       </g>
//     </svg>
//   );
// }
function Facebook(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    id: "_x30_6_-_INTERNET_KOPPELINGEN",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 21.8"
  }, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".facebook0{fill:#FFFFFF;}"
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "facebook",
    className: "facebook0",
    d: "M8.6,19.9v-7.8H5.9V9h2.6V6.5c0-2.7,1.6-4.1,4-4.1c1.1,0,2.1,0.1,2.4,0.1v2.8h-1.6 c-1.3,0-1.5,0.6-1.5,1.5V9h2.9l-0.4,3.1h-2.6v7.8H8.6z"
  }), /*#__PURE__*/_react["default"].createElement("g", null), /*#__PURE__*/_react["default"].createElement("g", null), /*#__PURE__*/_react["default"].createElement("g", null), /*#__PURE__*/_react["default"].createElement("g", null), /*#__PURE__*/_react["default"].createElement("g", null), /*#__PURE__*/_react["default"].createElement("g", null));
}